import dayjs from "dayjs";
import "dayjs/locale/ru";
import localeData from "dayjs/plugin/localeData";
import quarterOfYear from "dayjs/plugin/quarterOfYear";
import weekday from "dayjs/plugin/weekday";
import moment from "moment";
import "moment/locale/ru";

moment.updateLocale("ru", {
  week: {
    dow: 1,
  },
});

dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(quarterOfYear);
dayjs.locale("ru");

export default moment;
